import React,{useEffect} from 'react'
import { hot } from 'react-hot-loader/root'
import AOS from 'aos'
import { Routes } from './Config/routes'
import { createTheme, ThemeProvider } from '@mui/material/styles'
import './App.css'
import 'antd/dist/antd.min.css'
import {
  Singolo_Plancton_1, Giocatori, SliderInfinite,
  Dificolta, Singolo_Plancton_2, Singolo_Plancton_3,
  Singolo_Gamberone_1, Singolo_Gamberone_2,
  Singolo_Gamberone_3, Singolo_Astice_1, Singolo_Astice_3,
  Singolo_Astice_2, Coppia_Plancton_1, Coppia_Plancton_2, Avvia_Partita2,
  Coppia_Astice_2
} from './Screens/index'
import { Home, Instructions} from './Screens/index'
import Champion from './Screens/Champion/Champion'
import Loss from './Screens/Loss/Loss'
// AOS.init()

const theme = createTheme({
  palette: {
    primary: {
      main: '#007aff',
      secondMain: '#1890ff'
    }
  }
})

const App = () => {
  useEffect(() => {
    AOS.init();

    const clearLocalStorage = () => {
      localStorage.clear(); // Remove all data from local storage
    };

    window.addEventListener('beforeunload', clearLocalStorage);

    return () => {
      window.removeEventListener('beforeunload', clearLocalStorage);
    };
  }, []);
  return (
    <div>
      <Home/>
      {/* <Instructions /> */}
      
  
    </div>
  )
}

export default hot(App)